import { Component, EventEmitter, Inject, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';

@Component({
  selector: 'lifedi-questionInf-ranking',
  templateUrl: './question-inf-ranking.component.html',
  styleUrls: ['./question-inf-ranking.component.scss']
})
export class QuestionInfRankingComponent implements OnInit {
  @Input() informantForm: FormGroup;
  @Input() isEditValue: boolean;
  @Input() questionIndex: number;

  @Output() sendArr = new EventEmitter();
  informantArray: any[] = []
  modalData: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private gbFunction: GobalFunctionService
  ) {
    this.modalData = data;
  }

  ngOnInit(): void {
    if (!this.isEditValue) {
      if (!this.isEditValue) {
        this.modalData.informant_tag.forEach(e => {
          this.informantArray.push({
            tag: e,
            type: 'ranking',
            question: '',
            choices: [],
          })
        });
      }
    } else {
      let val_informant = JSON.parse(this.modalData.value.VALUE_INFORMANT);
      val_informant.splice(0, 1);
      this.informantArray = val_informant;

      for (let i = 0; i < this.modalData.value.VALUE[0].choices.length; i++) {
        this.informantFormArray.push(
          this.fb.group({
            choice_id: [this.modalData.value.VALUE[0].choices[i].choice_id, Validators.required],
            choice_detail: [this.modalData.value.VALUE[0].choices[i].choice_detail, Validators.required]
          })
        )
      }
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log(changes);
    if (changes.questionIndex) {
      // ดำเนินการอัปเดตตามต้องการที่นี่
      this.questionIndex = parseInt(changes.questionIndex.currentValue);
    }
  }

  addChoice(form) {
    form.push(
      this.fb.group({
        choice_id: form.value.length + 1,
        choice_detail: ['', Validators.required]
      })
    );
    console.log(this.informantArray.length);
    for (let i = 0; i < this.informantArray.length; i++) {
      const inf = this.informantArray[i];
      console.log(i);
      this.copyAddChoice(inf, form.value.length, i);
    }

    console.log(this.informantArray);
    console.log(this.informantForm.value);
  }

  copyAddChoice(inf, choice_id, index) {
    console.log(index, inf);
    let obj = {
      choice_detail: '',
      choice_id: choice_id
    }

    inf.choices.push(obj);
    console.log(inf);
  }

  get informantFormArray(): FormArray {
    return this.informantForm.get('choices') as FormArray;
  }

  // สำหรับ multi ใช้ลบคำถามย่อย
  deleteChoice(form, index) {
    form.removeAt(index);

    form.value.map((f, index) => {
      f.choice_id = index + 1;
    })
    for (let i = 0; i < this.informantArray.length; i++) {
      const inf = this.informantArray[i];
      this.deleteInformantChoice(inf, index);
    }

    console.log(this.informantArray);
  }

  deleteInformantChoice(inf, index) {
    inf.choices.splice(index, 1);
    inf.choices.map((el, index) => el.choice_id = index + 1)
  }

  copyArr() {
    console.log(this.informantArray);
    this.sendArr.emit(this.informantArray);
  }

  setQuestionInformant(question) {
    this.informantArray.forEach((el, i) => {
      if (!el.question) {
        el.question = question;
      }
    });
  }

  setChoiceInformant(choice, index) {
    this.informantArray.forEach((el, i) => {
      if (!el.choices[index].choice_detail) {
        el.choices[index].choice_detail = choice;
      }
    });
  }

}
